import { Record, List } from 'immutable';

//to support SCP and individaul catgeoryIDs per variant we need to add the category id to the translations DS

export const NameTranslationRecord = Record({
  id: undefined,
  description: undefined,
  language: '',
  name: ''
});
export default class CategoryTranslation extends Record({
  knowledgeCategoryId: undefined,
  id: -1,
  name: '',
  language: '',
  nameTranslations: List(),
  subcategories: List()
}) {}
CategoryTranslation.fromJS = json => {
  const convertedObject = {};
  if (!json.id && !json.knowledgeCategoryId) throw new Error('Invalid CategoryTranslationRecord JSON');
  convertedObject.id = json.id || json.knowledgeCategoryId;
  convertedObject.name = json.name;
  convertedObject.language = json.language;
  convertedObject.knowledgeCategoryId = json.knowledgeCategoryId;
  if (json.nameTranslations) {
    convertedObject.name = json.nameTranslations[0].name;
    convertedObject.nameTranslations = List(json.nameTranslations.map(NameTranslationRecord));
  }
  if (json.subcategories) {
    convertedObject.subcategories = List(json.subcategories.map(CategoryTranslation.fromJS));
  }
  return new CategoryTranslation(convertedObject);
};